"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationManager = exports.SiteDefaultAuth = exports.AuthLevel = exports.ErrorReason = void 0;
var SessionManager_1 = require("./SessionManager");
var rsa = require("../../external/rsa/rsa");
var webClientRequester_1 = require("../requester/webClientRequester");
var WebClientFetchRequester_1 = require("../requester/WebClientFetchRequester");
var vizPortalWebClientHelpers_1 = require("../api/vizPortalWebClientHelpers");
var LoginMethod_1 = require("../api/methods/LoginMethod");
var GeneratePublicKeyMethod_1 = require("../api/methods/GeneratePublicKeyMethod");
var LogoutMethod_1 = require("../api/methods/LogoutMethod");
// Start at 7-digit numbers so these don't collide with server error codes
var ErrorReason;
(function (ErrorReason) {
    ErrorReason[ErrorReason["Canceled"] = 1000001] = "Canceled";
    ErrorReason[ErrorReason["ResourceNotFound"] = 1000002] = "ResourceNotFound";
    ErrorReason[ErrorReason["Unauthorized"] = 1000003] = "Unauthorized";
    ErrorReason[ErrorReason["Unknown"] = 1000004] = "Unknown";
})(ErrorReason = exports.ErrorReason || (exports.ErrorReason = {}));
;
var AuthLevel;
(function (AuthLevel) {
    AuthLevel[AuthLevel["Anonymous"] = 0] = "Anonymous";
    AuthLevel[AuthLevel["Authenticated"] = 1] = "Authenticated";
    AuthLevel[AuthLevel["SiteAdmin"] = 2] = "SiteAdmin";
    AuthLevel[AuthLevel["SelfOrAdmin"] = 3] = "SelfOrAdmin";
    AuthLevel[AuthLevel["SelfOrServerAdmin"] = 4] = "SelfOrServerAdmin";
    AuthLevel[AuthLevel["ServerAdmin"] = 5] = "ServerAdmin";
})(AuthLevel = exports.AuthLevel || (exports.AuthLevel = {}));
var SiteDefaultAuth;
(function (SiteDefaultAuth) {
    SiteDefaultAuth[SiteDefaultAuth["Local"] = 0] = "Local";
    SiteDefaultAuth[SiteDefaultAuth["ActiveDirectory"] = 1] = "ActiveDirectory";
    SiteDefaultAuth[SiteDefaultAuth["SAML"] = 2] = "SAML";
    SiteDefaultAuth[SiteDefaultAuth["External"] = 3] = "External";
})(SiteDefaultAuth = exports.SiteDefaultAuth || (exports.SiteDefaultAuth = {}));
/**
 * This object contains methods for handling a users authentication.
 * It will also update a passed in SessionManager when a user's session is updated
 */
var AuthenticationManager = /** @class */ (function () {
    function AuthenticationManager(requester, sessionManager) {
        if (requester === void 0) { requester = new WebClientFetchRequester_1.WebClientFetchRequester(); }
        if (sessionManager === void 0) { sessionManager = new SessionManager_1.SessionManager(requester); }
        var wrappedRequester = new webClientRequester_1.WebClientRequesterWrapper(requester);
        this.sessionManager = sessionManager;
        this.generatePublicKey = wrappedRequester.createSender(GeneratePublicKeyMethod_1.GeneratePublicKeyMethod);
        this.sendLogin = wrappedRequester.createSender(LoginMethod_1.LoginMethod);
        this.sendLogout = wrappedRequester.createSender(LogoutMethod_1.LogoutMethod);
    }
    AuthenticationManager.prototype.login = function (username, password, siteUrlName) {
        var _this = this;
        return this.sessionManager.sessionInfoRequest(function () {
            return _this
                .generatePublicKey()
                .then(vizPortalWebClientHelpers_1.getSuccessResult)
                .then(function (generatePublicKeyResult) {
                return _this.sendLogin({
                    username: username,
                    encryptedPassword: rsa.encrypt(password, generatePublicKeyResult.key),
                    keyId: generatePublicKeyResult.keyId,
                    siteUrlName: siteUrlName
                });
            })
                .then(vizPortalWebClientHelpers_1.getSuccessResult);
        });
    };
    AuthenticationManager.prototype.signOut = function () {
        var _this = this;
        var logoutResultToReturn;
        return this.sessionManager.sessionInfoRequest(function () {
            return _this
                .sendLogout()
                .then(vizPortalWebClientHelpers_1.getSuccessResult)
                .then(function (logoutResult) {
                logoutResultToReturn = logoutResult;
            });
        })
            .then(function () { return logoutResultToReturn; });
    };
    return AuthenticationManager;
}());
exports.AuthenticationManager = AuthenticationManager;
//# sourceMappingURL=AuthenticationManager.js.map